import React from 'react'
import PropTypes from 'prop-types'

const IsZoneContent = ({ page, component, ...others }) => {
  const zoneId = component?.getParameters()?.zoneId
  const isCMS = !!new URLSearchParams(window.location.search).get('token')
  const isPreview = page.isPreview()
  const showZoneContainer = isCMS && isPreview
  const zoneContainerClass = showZoneContainer
    ? 'u-bgColorLight u-marginVert2gu u-padding2gu u-textCenter Card'
    : ''

  if (!zoneId) {
    return <>{others.children}</>
  }

  return (
    <div className={`is-zone ${zoneContainerClass}`} id={zoneId}>
      {showZoneContainer ? (
        <h4>
          Interaction studio campaign id :
          <span className="u-textBold u-marginLeft1gu">{zoneId}</span>
        </h4>
      ) : null}
      {others.children}
    </div>
  )
}

IsZoneContent.propTypes = {
  page: PropTypes.shape({
    isPreview: PropTypes.func,
  }),
  component: PropTypes.shape({
    getParameters: PropTypes.func,
  }),
}

export default IsZoneContent
